import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Skeleton from '@mui/material/Skeleton';

export default function FormSkeleton() {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack gap={2} sx={{ mb: 4 }}>
        <Stack direction="column" alignItems="flex-start" gap={2} width="100%">
          <Skeleton variant="rounded" width={200} height={24} />
          <Skeleton variant="rounded" width={750} height={20} />
          <Stack flexDirection="row">
            <Skeleton variant="rounded" width={450} height={40} />
          </Stack>
          <Stack flexDirection={'row'} mt={1}>
            <Skeleton variant="rounded" width={450} height={40} />
            <Stack width={400} height={40}></Stack>
          </Stack>
          <Stack flexDirection={'row'} mt={1}>
            <Skeleton variant="rounded" width={450} height={40} />
            <Stack width={400} height={40}></Stack>
          </Stack>
          <Stack flexDirection={'row'} mt={1}>
            <Skeleton variant="rounded" width={300} height={60} />
            <Stack width={400} height={40}></Stack>
          </Stack>
        </Stack>
        <Stack
          direction="column"
          alignItems="flex-start"
          gap={1}
          width="100%"
          mt={5}
        >
          <Skeleton variant="rounded" width={200} height={24} />
          <Skeleton variant="rounded" width={700} height={20} />
        </Stack>
        <Stack flexDirection={'row'} gap={4}>
          <Skeleton variant="rounded" width={400} height={40} />
          <Stack width={400} height={40}></Stack>
        </Stack>
      </Stack>
    </Box>
  );
}
